import { Component, OnInit, Injector, Input } from '@angular/core';
import { MasonryItemModel } from '../../masonry/masonry.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ConsumerService } from '../../../services/consumer.service';
import { DataService } from '../../../services/data.service';
import { ConsumerModel } from '../../../models/consumer/consumer.model';
import { ConsumerDetailInjector } from '../consumer-detail-injector';
import { AccountBalanceItemComponent } from '../grid-item/account-balance-item.component';
import { BillItemComponent } from '../grid-item/bill-item.component';
import { CreditStatusItemComponent } from '../grid-item/credit-status-item.component';
import { PaymentItemComponent } from '../grid-item/payment-item.component';
import { MeterConsumptionItemComponent } from '../grid-item/meter-consumption-item.component';
import { TarrifItemComponent } from '../grid-item/tarrif-item.component';
import { WidgetType } from '../../../models/consumer/widget-issues-type.model';

@Component({
    selector: 'consumer-detail-account',
    templateUrl: './consumer-detail-account.component.html',
})
export class ConsumerDetailAccountComponent implements OnInit {

    public subscriptions: any[] = [];
    @Input() clientId: number;
    @Input() consumerId: string;
    @Input() consumerIssues: any[] = [];
    @Input() consumer: ConsumerModel;

    constructor(private dataService: DataService,
        private route: ActivatedRoute,
        private injector: Injector) { }

    masonryItems: MasonryItemModel[] = [];
    consumerHasPayg: boolean = false;
    consumerHasBilling: boolean = false;
    accountInjector: any;
    billInjector: any;
    creditStatusInjector: any;
    meterInjector: any;
    paymentInjector: any;
    accountBalanceIssues: any[];
    billIssues: any[];
    creditStatusIssues: any[];
    meterConsumptionIssues: any[];
    paymentsIssues: any[];

    ngOnInit() {

        this.consumerId = this.route.snapshot.params['consumerId'];
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.consumerHasPayg = (this.consumer.consumerType === 'PAYG') ? true : false;
        this.consumerHasBilling = (this.consumer.consumerType === 'Billing') ? true : false;
    }

    ngOnChanges(changes: any) {
        for (let propName in changes) {
            let chng = changes[propName];
            if (propName == "clientId") { this.clientId = chng.currentValue; }
            if (propName == "consumerId") { this.consumerId = chng.currentValue; }
            if (propName == "consumer") { this.consumer = chng.currentValue; }
            if (propName == "consumerIssues") { this.consumerIssues = chng.currentValue; }
        }

        if (this.consumerIssues) {
            this.accountBalanceIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.AccountBalance);
            this.billIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.Bills);
            this.creditStatusIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.CreditStatus);
            this.meterConsumptionIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.MeterConsumption);
            this.paymentsIssues = this.consumerIssues.filter(x => x.relatedWidget == WidgetType.Payments);

            this.accountInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.accountBalanceIssues ? this.accountBalanceIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.billInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.billIssues ? this.billIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.creditStatusInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.creditStatusIssues ? this.creditStatusIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);

            this.paymentInjector = Injector.create([
                { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
            ], this.injector);
        }

        this.consumerHasPayg = (this.consumer.consumerType === 'PAYG') ? true : false;
        this.consumerHasBilling = (this.consumer.consumerType === 'Billing') ? true : false;

        this.accountInjector = Injector.create([
            { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.accountBalanceIssues ? this.accountBalanceIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
        ], this.injector);

        this.billInjector = Injector.create([
            { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.billIssues ? this.billIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
        ], this.injector);

        this.creditStatusInjector = Injector.create([
            { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.creditStatusIssues ? this.creditStatusIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
        ], this.injector);

        this.paymentInjector = Injector.create([
            { provide: ConsumerDetailInjector, useValue: new ConsumerDetailInjector(this.paymentsIssues ? this.paymentsIssues : [], this.consumerHasPayg, this.consumerHasBilling) }
        ], this.injector);

        if (this.consumerHasPayg) {
            this.masonryItems = [
                {
                    component: AccountBalanceItemComponent,
                    injector: this.accountInjector
                },
                {
                    component: BillItemComponent,
                    injector: this.billInjector

                },
                {
                    component: CreditStatusItemComponent,
                    injector: this.creditStatusInjector
                },
                {
                    component: PaymentItemComponent,
                    injector: this.paymentInjector
                }
            ]
        } else if (this.consumerHasBilling) {

            this.masonryItems = [
                {
                    component: AccountBalanceItemComponent,
                    injector: this.accountInjector
                },
                {
                    component: BillItemComponent,
                    injector: this.billInjector
                },
                {
                    component: PaymentItemComponent,
                    injector: this.paymentInjector
                }
            ]
        }

        // update isExpandable per item, if data is resolved
        this.subscriptions.push(this.dataService.accountBalanceItemComponentResolved.subscribe(
            result => this.masonryItems.find(x => x.component == AccountBalanceItemComponent).isExpandable = result
        ));
        this.subscriptions.push(this.dataService.billItemComponentResolved.subscribe(
            result => this.masonryItems.find(x => x.component == BillItemComponent).isExpandable = result
        ));
        this.subscriptions.push(this.dataService.paymentItemComponentResolved.subscribe(
            result => this.masonryItems.find(x => x.component == PaymentItemComponent).isExpandable = result
        ));

        if (this.consumerHasPayg) {
            this.subscriptions.push(this.dataService.creditStatusItemComponentResolved.subscribe(
                result => {                    
                    this.masonryItems.find(x => x.component == CreditStatusItemComponent).isExpandable = result;
                }
            ));
        }
    }
}
